import { PropertyDetailsType } from '__core/shared/model/finance/PropertyDetails.enum';
import template from './asset.template.html';

export default {
  template,
  bindings: {
    asset: '<',
    assets: '<',
    contacts: '<',
    workflow: '<',
    countries: '<',
    lenders: '<',
    validationErrors: '<',
    idTicket: '<',
    ticketOwner: '<',
    isContactAsset: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      $document,
      helperService,
      dateTimeService,
      assetsService,
      Asset,
      BankAccountType,
      PropertyType,
      VehicleType,
      ZoningOption,
      GOOGLEMAPS
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.organizationCountry = helperService.getOrganizationCountry();
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.availableOpportunityTypes = [];
      ctrl.availableOpportunityContextualTypes = [];
      ctrl.availableOpportunitySelectionTypes = [];
      ctrl.organizationCountry = null;
      ctrl.availableStates = [];
      ctrl.availableZoneOptions = [];
      ctrl.availablePropertyTypes = [];
      ctrl.availableVehicleTypes = [];
      ctrl.availableBankAccountTypes = [];
      ctrl.propertyDetails = {};
      ctrl.searchTerm = '';
      ctrl.otherDateFormat = $rootScope.CurrentDateFormatSecondary();
      ctrl.dateFormat = helperService.setOtherDateFormat;
      ctrl.showPropertyDetails = false;
      ctrl.isPropertyChanged = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.googleAutocompleteOptions = {
          componentRestrictions: GOOGLEMAPS.restrictToCountries
        };

        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availableZoneOptions = ZoningOption.available();
        ctrl.availablePropertyTypes = PropertyType.available();
        ctrl.availableVehicleTypes = VehicleType.available();
        ctrl.availableBankAccountTypes = BankAccountType.available();
        ctrl.asset = ctrl.asset || {};
        ctrl.assets = ctrl.assets || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.countries = ctrl.countries || [];
        ctrl.lenders = ctrl.lenders || [];
        if (ctrl.lenders.length) {
          ctrl.mortgageLoanLenders = _.chain(ctrl.lenders)
            .filter((l) => l.type.indexOf('RESIDENTIAL') > -1)
            .sortNatural('name')
            .sortNatural('group')
            .value();
        }
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.isContactAsset = ctrl.isContactAsset || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.index = _.findIndex(ctrl.assets, (a) => a?.id === ctrl.asset?.id);
        ctrl.searchType = '';
        if (!_.isEmpty(ctrl.ticketOwner)) {
          if (
            ctrl.ticketOwner?.isRpDataEnabled() &&
            !ctrl.ticketOwner?.isPriceFinderEnabled()
          ) {
            ctrl.searchType = PropertyDetailsType.rp_data.name;
          }
          if (
            ctrl.ticketOwner?.isPriceFinderEnabled() &&
            !ctrl.ticketOwner?.isRpDataEnabled()
          ) {
            ctrl.searchType = PropertyDetailsType.pricefinder.name;
          }
        }

        dateTimeService.getSet(ctrl, ctrl.asset, 'vehicleBuildDate', 'getSetVehicleBuildDate');
        dateTimeService.getSet(ctrl, ctrl.asset, 'asAtDate', 'getSetAsAtDate');
      };

      ctrl.isStateValid = (state) => helperService.isStateValid(state);

      ctrl.clearSearchTerm = () => {
        ctrl.searchTerm = '';
      };

      ctrl.getContact = (idContact) => {
        let contact;
        if (ctrl.contacts.length) {
          contact = ctrl.contacts.find((c) => c.id === idContact);
        }
        return contact;
      };

      ctrl.editOwnership = ($event, asset) =>
        helperService
          .editOwnershipOfAssetOrLiability({
            event: $event,
            item: asset,
            contacts: ctrl.contacts,
            isDisabled: ctrl.isTicketSettled
          })
          .then((result) => {
            ctrl.asset = Asset.build(result);
            ctrl.saveAsset();
          });

      ctrl.hasPropertyDetails = (propertyDetails) =>
        !_.isEmpty(propertyDetails) &&
        propertyDetails?.type?.name === ctrl.searchType &&
        propertyDetails?.idOwner === ctrl.ticketOwner?.id;

      ctrl.toggleWillItBecomeInvestment = () => {
        if (!ctrl.asset.willItBecomeInvestment) {
          ctrl.asset.monthlyRentalIncome = 0;
        } else {
          ctrl.asset.numberOfBoarders = 0;
          ctrl.asset.allInclusive = false;
        }
        ctrl.saveAsset();
      };

      ctrl.toggleWillItBecomeOwnerOccupied = () => {
        if (!ctrl.asset.willItBecomeOwnerOccupied) {
          ctrl.asset.monthlyRentalIncome = 0;
          ctrl.asset.numberOfBoarders = 0;
          ctrl.asset.allInclusive = false;
        }
        ctrl.saveAsset();
      };

      ctrl.changeMonthlyRentalIncome = () => {
        if (ctrl.organizationCountry.cca2 === 'NZ' && ctrl.asset.monthlyRentalIncome === 0) {
          ctrl.asset.numberOfBoarders = 0;
          ctrl.asset.allInclusive = false;
        }
        ctrl.saveAsset();
      };

      ctrl.isLenderSelected = (asset) => {
        if (asset.name !== '' && ctrl.lenders.length) {
          const lS = ctrl.lenders.find((l) => l.abbr.toLowerCase() === asset.name);
          return lS !== undefined;
        }
        return true;
      };

      ctrl.changeProperty = (data) => {
        ctrl.showPropertyDetails = data?.isReady;
        ctrl.isPropertyChanged = !data?.isReady;
      };

      ctrl.setPropertyData = (data) => {
        ctrl.propertyDetails = data?.propertyDetails;
      };

      ctrl.isAssetTypeOwnerOccupied = () =>
        helperService.isAssetTypeOwnerOccupied(ctrl.asset.assetType);

      ctrl.isAssetTypeInvestment = () =>
        helperService.isAssetTypeInvestment(ctrl.asset.assetType);

      ctrl.isAssetTypeOwnerOccupiedOrInvestment = () =>
        helperService.isAssetTypeOwnerOccupiedOrInvestment(ctrl.asset.assetType);

      ctrl.isAssetTypeVehicle = () => helperService.isAssetTypeVehicle(ctrl.asset.assetType);

      ctrl.isAssetTypeBankAccount = () =>
        helperService.isAssetTypeBankAccount(ctrl.asset.assetType);

      ctrl.isAssetTypeHomeContents = () =>
        helperService.isAssetTypeHomeContents(ctrl.asset.assetType);

      ctrl.isAssetTypeKiwiSaver = () =>
        helperService.isAssetTypeKiwiSaver(ctrl.asset.assetType);

      ctrl.isAssetTypeSuperfund = () =>
        helperService.isAssetTypeSuperfund(ctrl.asset.assetType);

      ctrl.isAssetTypeShares = () => helperService.isAssetTypeShares(ctrl.asset.assetType);

      ctrl.isAssetTypeOther = () => helperService.isAssetTypeOther(ctrl.asset.assetType);

      ctrl.isAssetTypeBalanceSheet = () =>
        helperService.isAssetTypeBalanceSheet(ctrl.asset.assetType);

      ctrl.areAllFieldsFilled = () => {
        const collection = [];
        if (ctrl.isAssetTypeOwnerOccupiedOrInvestment()) {
          collection.push(
            ctrl?.asset?.address?.streetNumber !== '',
            ctrl?.asset?.address?.street !== '',
            ctrl?.asset?.address?.country !== ''
          );
          if (ctrl.organizationCountry.cca2 === 'AU') {
            collection.push(
              ctrl?.asset?.address?.state !== '',
              ctrl?.asset?.address?.suburb !== ''
            );
          }
          if (
            ctrl.organizationCountry.cca2 === 'NZ' &&
            ctrl?.asset?.monthlyRentalIncome > 0 &&
            ((ctrl.isAssetTypeOwnerOccupied() && !ctrl.asset.willItBecomeInvestment) ||
              ctrl?.asset?.willItBecomeOwnerOccupied)
          ) {
            collection.push(ctrl?.asset?.numberOfBoarders > 0);
          }
        } else {
          collection.push(ctrl.asset.name !== '');
          if (ctrl.isAssetTypeBankAccount() && ctrl.asset.name.toLowerCase() === 'other') {
            collection.push(ctrl.asset.bankOtherName !== '');
          }
        }
        collection.push(ctrl.asset.value > 0);
        return _.every(collection, (c) => c === true);
      };

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.saveAsset = () => {
        ctrl.onFinished({ asset: ctrl.asset });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
